// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.scramberry",
    name: "ScramberryWallet",
    homepage: "https://scramberry.io/ja/wallet/",
    image_id: "2398a924-62b4-4f64-4a59-7ae7a293ce00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/jp/app/scramberry-wallet/id6468808512",
        android: "https://play.google.com/store/apps/details?id=io.scramberry.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "io.scramberry.v7bmfgda1vo42ue385xc://deeplink",
        universal: "https://link1.bsg.scramberry.io",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map